module.exports = __webpack_public_path__ + "static/Weisse-Schokolade-7c8b16a08dead15359f11ed3cd6f68e1.png";